import MetamaskIcon from 'app/components/icons/MetamaskIcon';
import NasLogoIcon from 'app/components/icons/NasLogoIcon';
import RightArrowWithCircle from 'app/components/icons/RightArrowWithCircle';
import Modal from 'app/components/Modal';
import React from 'react';
import style from './WalletOptionModal.module.scss';
import config from '../../../helpers/config';
import Loading from 'app/components/Loading';

type WalletOptionModalProps = {
  open: boolean;
  onClose?: (...args: any[]) => void;
  walletList?: Array<{
    logoType: string;
    name: string;
    extraInfo?: string;
    onClick?: (...args: any[]) => void;
  }>;
  isRedirectLPError?: boolean;
  isLoading?: boolean;
  isNftClaimFlow?: boolean;
};

const logoMapper = {
  metamaskLogo: <MetamaskIcon />,
  nasLogo: <NasLogoIcon />,
};

const WalletOptionModal = ({
  open,
  walletList,
  onClose,
  isRedirectLPError,
  isLoading,
  isNftClaimFlow,
}: WalletOptionModalProps) => {
  const className = 'c-WalletOptionModal';
  const title = isNftClaimFlow ? 'Claim your token with' : 'Connect Wallet';
  return (
    <Modal
      open={open}
      showCloseIcon={false}
      onClose={onClose}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <p className={style[`${className}__title`]}>{title}</p>
        <div className={style[`${className}__list`]}>
          {walletList?.map((wallet, index) => {
            const { logoType, name, extraInfo, onClick } = wallet;
            const logo = logoMapper?.[logoType] ?? null;

            return (
              <div
                className={style[`${className}__list__item`]}
                onClick={onClick}
                key={index}
              >
                <div className={style[`${className}__list__item__content`]}>
                  {logo}
                  <p className={style[`${className}__list__item__text`]}>
                    {name}
                  </p>
                </div>
                <p className={style[`${className}__list__item__hidden`]}>
                  {extraInfo}
                </p>
              </div>
            );
          })}
        </div>
        {isRedirectLPError && (
          <div className={style[`${className}__error`]}>
            <p className={style[`${className}__error__text`]}>
              Currently your metamask wallet is not connected yet. Please ensure
              that your Nas Academy email ID account has at least one token.
            </p>
            <p className={style[`${className}__error__text`]}>
              Below are the list of courses that you can get your 1st token.
            </p>
            <ul className={style[`${className}__error__list`]}>
              <li className={style[`${className}__error__list__item`]}>
                How to Master NFTs in 7 Days by Ben Yu
              </li>
            </ul>
            <div
              className={style[`${className}__error__link`]}
              // @ts-ignore
              onClick={() => (window.location.href = config.learningPortalUrl)}
            >
              Go to learning portal
              <RightArrowWithCircle />
            </div>
          </div>
        )}
        {isLoading && (
          <div className={style[`${className}__loading`]}>
            <Loading />
          </div>
        )}
      </div>
    </Modal>
  );
};

WalletOptionModal.defaultProps = {
  walletList: [],
};

export default WalletOptionModal;
